import React from "react";

const EyeClosed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14.9729 10.5C15.837 9.40962 16.2918 8.49998 16.2918 8.49998C16.2918 8.49998 13.4585 2.83331 8.50016 2.83331C8.15655 2.83331 7.82315 2.86053 7.50018 2.91118M4.50018 4.14468C2.04925 5.81847 0.708496 8.49998 0.708496 8.49998C0.708496 8.49998 3.54183 14.1666 8.50016 14.1666C10.0477 14.1666 11.3882 13.6147 12.5002 12.8553"
          stroke="#EA6B3D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.80663 7.216C6.53576 7.57269 6.375 8.01756 6.375 8.49999C6.375 9.67359 7.32639 10.625 8.5 10.625C8.94839 10.625 9.36435 10.4861 9.7072 10.249"
          stroke="#EA6B3D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 1L15.75 14.75"
          stroke="#EA6B3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeClosed;
